import { createContext } from 'react';

/**
 * __Inside theme provider context__
 */
export const InsideThemeProviderContext = createContext(false);
